import React from "react";
import { atom, useRecoilState } from "recoil";
import styled from "styled-components";
import {
  PointTabColumn,
  PointTabContainer,
  PointTabText,
  STabBar,
} from "../../Benefit/Point/PointTab";

export const partyInviteTabState = atom<number>({
  key: "partyInviteTabState",
  default: 2,
});

export default function PartyInviteTab() {
  const [tab, setTab] = useRecoilState(partyInviteTabState);

  return (
    <PointTabContainer style={{ position: "relative" }}>
      <PointTabColumn onClick={() => setTab(2)}>
        <PointTabText isActive={Boolean(tab === 2)}>세컨더리 방식</PointTabText>
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(0)}>
        <PointTabText isActive={Boolean(tab === 0)}>인바이트 방식</PointTabText>
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(1)}>
        <PointTabText isActive={Boolean(tab === 1)}>레지스터 방식</PointTabText>
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(3)}>
        <PointTabText isActive={Boolean(tab === 3)}>
          링크 초대 방식
        </PointTabText>
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(4)}>
        <PointTabText isActive={Boolean(tab === 4)}>
          링키드 메일 방식
        </PointTabText>
      </PointTabColumn>

      <PointTabBar tab={tab} />
    </PointTabContainer>
  );
}

const PointTabBar = styled.div<STabBar>`
  position: absolute;
  width: 100px;
  height: 3px;
  background-color: ${({ theme }) => theme.color.gray900};
  bottom: -8px;
  left: ${({ tab }) =>
    tab === 4
      ? 486
      : tab === 3
      ? 355
      : tab === 2
      ? 0
      : tab === 1
      ? 234
      : 116}px;

  transition: left 0.2s ease;
`;
